import React from "react"
import { FaExternalLinkAlt, FaLink } from "react-icons/fa"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Fred Robinsons</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                Developed by{" "}
                <a
                  href="https://www.zithas.co.uk/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-primary"
                >
                  Zithas Technologies.
                  <FaExternalLinkAlt className="ms-2" />
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
